import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ConfigurationFacade } from '../../facades/configuration.facade';

@Component({
  selector: 'app-full-page-loader',
  templateUrl: './full-page-loader.component.html',
  styleUrls: ['./full-page-loader.component.scss'],
  standalone: false,
})
export class FullPageLoaderComponent implements OnInit, OnDestroy {
  private configFacade: ConfigurationFacade = inject(ConfigurationFacade);

  isActive: boolean = true;
  currentPageLoadingList: string[] = [];
  loaderImageUrl: string = environment.defaultBannerImg;

  @Input() waitingList: string[] = [];

  private unsubscribe$: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    this.selectFullPageLoaderList();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  selectFullPageLoaderList(): void {
    this.configFacade.selectFullPageLoaderList().pipe(
      takeUntil(this.unsubscribe$),
    ).subscribe(state => {
      this.currentPageLoadingList = state;

      if (state.length > 0 && this.waitingList.length > 0 && this.waitingList.every(entity => state.includes(entity))) {
        this.isActive = false;
      }
    });
  }
}
